import { observable, action, computed, configure, runInAction } from "mobx";
import { createContext } from "react";
import { IEmployee } from "../models/employee";
import { toast } from "react-toastify";
import agent from "../api/agent";

configure({ enforceActions: "always" });

class EmployeeProfileStore {
  @observable employee: IEmployee | null = null;
  @observable loadingInitial = false;
  @observable submitting = false;
  @observable target = "";

  @action loadEmployeeProfile = async () => {
    this.loadingInitial = true;
    try {
      const employee = await agent.EmployeeProfiles.details();
      runInAction("getting employee Profile", () => {
        employee.dob = employee.dob.substr(0, 10);
        employee.startDate = employee.startDate.substr(0, 10);
        this.employee = employee;
        this.loadingInitial = false;
      });
      return employee;
    } catch (error) {
      runInAction("get employee Profile error", () => {
        this.loadingInitial = false;
      });
      toast.error("get employee Profile error");
      console.log(error);
    }
  };

  @action clearEmployee = () => {
    this.employee = null;
  };

  @action editEmployee = async (employee: IEmployee) => {
    this.submitting = true;
    try {
      await agent.EmployeeProfiles.update(employee);
      runInAction("editing employee", () => {
        this.employee = employee;
        this.submitting = false;
      });
    } catch (error) {
      runInAction("get employee Profile error", () => {
        this.loadingInitial = false;
      });
      toast.error("get employee Profile error");
      console.log(error);
    }
  };
}

export default createContext(new EmployeeProfileStore());
